(function () {
class RancoldCategoryRail {
  constructor(root) {
    if (root.dataset.railInitialized === 'true') return;

    this.root = root;
    this.scroller = root.querySelector('[data-rc-rail-scroller]');
    this.previousButtons = [...root.querySelectorAll('[data-rc-rail-previous]')];
    this.nextButtons = [...root.querySelectorAll('[data-rc-rail-next]')];

    if (!this.scroller) return;

    root.dataset.railInitialized = 'true';
    this.previousButtons.forEach((button) => button.addEventListener('click', () => this.scroll(-1)));
    this.nextButtons.forEach((button) => button.addEventListener('click', () => this.scroll(1)));
    this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons(), { passive: true });
    requestAnimationFrame(() => this.updateButtons());
  }

  scroll(direction) {
    const distance = Math.max(this.scroller.clientWidth * 0.72, 280);
    this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const hasOverflow = maxScroll > 4;

    this.root.classList.toggle('rc-category-rail--overflowing', hasOverflow);
    this.previousButtons.forEach((button) => {
      button.disabled = !hasOverflow || this.scroller.scrollLeft <= 4;
    });
    this.nextButtons.forEach((button) => {
      button.disabled = !hasOverflow || this.scroller.scrollLeft >= maxScroll - 4;
    });
  }
}

const initializeRancoldCategoryRails = (scope = document) => {
  scope.querySelectorAll('[data-rc-category-rail]').forEach((root) => new RancoldCategoryRail(root));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeRancoldCategoryRails());
} else {
  initializeRancoldCategoryRails();
}

document.addEventListener('shopify:section:load', (event) => initializeRancoldCategoryRails(event.target));
})();
